<template>
  <button
    class="button-icon"
    :style="`background-color: ${backgroundColor}`"
  >
    <slot />
    <Icon
      class="styled-icon"
      :icon="icon"
      :fillColor="fillColor"
      :strokeColor="strokeColor"
    />
  </button>
</template>

<script>
import Icon from '@/components/Icon.vue'

export default {
  name: 'ButtonIcon',
  components: {
    Icon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      default: 'black'
    },
    fillColor: {
      type: String,
      default: 'white'
    },
    strokeColor: {
      type: String,
      default: 'white'
    }
  }
}
</script>

<style lang="scss" scoped>
.button-icon {
  @include flex(row, center, center);
  padding: 12px;
  background-color: var(--background);
  cursor: pointer;
  color: black;
}
.icon{
  ::v-deep svg {
      $s: 22px;
      width: $s;
      height: $s;
  }
}
</style>
